import styled from "styled-components";

export const ConditionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const ConditionFormContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  margin-bottom: 24px;

  input {
    border-radius: 8px;
    border: 1px solid ${props => props.theme.colors.clearGray};
    background: ${props => props.theme.colors.primaryWhite};
    height: 40px;
    padding: 9px 16px;
  }

  select {
    border-radius: 8px;
    border: 1px solid ${props => props.theme.colors.clearGray};
    background: ${props => props.theme.colors.primaryWhite};
    height: 40px;
    padding: 9px 16px;
  }

  label {
    color: ${props => props.theme.colors.clearGray};
  }
`;

export const ConditionFormColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  gap: 32px;
`;

export const ConditionSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 1032px;
  gap: 16px;
`;

export const ConditionsActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;